<template>
  <v-container fluid>
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <confirm-modal
      :dialog="showConfirm"
      :message="confirmMessage"
      @confirm="confirmResponse($event)"></confirm-modal>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h4 class="green--text headline mb-0">Jugadores</h4>
      </v-flex>
      <v-flex xs6 md5 text-xs-right>
        <v-tooltip left>
          <v-btn
            dark
            color="green"
            slot="activator"
            fab
            small>
              <v-icon>add</v-icon>
            </v-btn>
          <span>Nuevo Jugador</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-text-field
          box
          name="searchbar"
          label="Buscar jugadores"
          append-icon="search"
          class="white--text"
          v-model="filter"></v-text-field>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-switch
          v-model="seeDisabledPlayers"
          green
          color="green"
          slot="activator"
          :label="'Ver inhabilitados'">
        </v-switch>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-data-table
        :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="currentPlayers"
          :search="filter"
          class="elevation-1"
          light
          :loading="tableLoading"
          rows-per-page-text="Filas por página"
          >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left green--text">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.lastname }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "Players",
  data: () => ({
    messageLoader: 'Cargando Información',
    filter: '',
    seeDisabledPlayers: false,
    actionSelected: '',
    playerSelected: [],
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres inhabilitar al jugador?',
    players: [],
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    headers: [
      { text: 'Nombre', value: 'name', align: 'left' },
      { text: 'Apellido', value: 'lastname', align: 'left' },
    ]
  }),
  mounted() {
    this.loadPlayers()
  },
  computed: {
    ...mapGetters([
      'currentPlayers'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadPlayers'
    ]),
    disablePlayer(event, player) {
      this.actionSelected = 'disablePlayer'
      this.playerSelected = team
      this.confirmMessage = '¿Estas seguro que quieres inhabilitar al jugador?'
      this.showConfirm = true
    },

    confirmResponse(response) {
      if(response){
        //En caso la respuesta del usuario sea positiva
        if(this.actionSelected === 'disablePlayer')
          this.playerSelected.status = !this.playerSelected.status
      }else {
        //En caso la respuesta del usuario sea negativa
      }
      this.showConfirm = false
    }
  }
}
</script>
<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/players/players.vue